<template>
	<div class="flex flex-shrink flex-col" style="height: 800px; min-height: 500px; position: relative">
		<div class="flex flex-shrink">
			<img src="../../../../assets/ads_preview_image_clean.png" alt="" class="flex flex-shrink relative" style="height: 800px" />
		</div>
		<div
			class="absolute mt-32 mx-12 p-4 bg-white rounded-lg shadow z-10"
			style="width: 310px; min-height: 200px; max-height: 600px; overflow-y: scroll"
		>
			<div class="flex flex-col w-full pr-0 md:pr-4 font-bold">
				{{ specialOffer.headline == null ? $t('title') : specialOffer.headline }}
			</div>
			<div class="flex w-full pr-0 md:pr-4 flex-row text-gray-600 mt-1">
				<font-awesome-icon :icon="['fas', 'calendar']" class="mr-2" style="align-self: center" />
				<div>
					{{ specialOffer.start == null ? $t('start_date') : getGermanDate(specialOffer.start) }} -
					{{ specialOffer.end == null ? $t('end_date') : getGermanDate(specialOffer.end) }}
				</div>
			</div>
			<div class="flex w-full pr-0 md:pr-4 flex-col mt-1 text-left" style="white-space: pre-line">
				{{ specialOffer.content == null ? $t('ad_content_hint') : specialOffer.content }}
			</div>
			<div v-if="backgroundImage" class="w-full mt-5">
				<img
					alt=""
					:src="backgroundImage"
					class="object-contain max-h-full justify-center w-full"
					style="align-content: center; text-align: center; object-fit: cover; background: #e4e5e4;"
				/>
			</div>
			<div v-if="videoContent" class="w-full mt-5">
				<video controls :src="videoContent" style="max-height: 600px"></video>
			</div>
			<div class="flex w-full justify-center mt-5">
				{{ $t('make_appointment') }}
			</div>
			<div class="flex px-10 text-grey-600 justify-between mb-2" style="align-self: center; align-items: center; text-align: center">
				<font-awesome-icon :icon="['fas', 'phone']" class="w-10 h-10" size="lg" style="align-self: center; color: grey" />
				<font-awesome-icon :icon="['fas', 'envelope']" class="w-10 h-10" size="lg" style="align-self: center; color: grey" />
				<font-awesome-icon :icon="['fas', 'comment']" class="w-10 h-10" size="lg" style="align-self: center; color: grey" />
			</div>
		</div>
	</div>
</template>
<script>
import { getGermanDate } from '@/plugins/Utils';

export default {
	name: 'SmartphonePreviewComponent',
	methods: { getGermanDate },
	props: {
		specialOffer: {},
		backgroundImage: {},
		videoContent: null,
	},
};
</script>
